/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListReservationsResponse {
    getFixupPrototypeFunction() { return ListReservationsResponse.fixupPrototype; }

    static newInstance(model: Partial<ListReservationsResponse>): ListReservationsResponse {
        let obj = Object.assign(new ListReservationsResponse(), model);
        ListReservationsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListReservationsResponse>): ListReservationsResponse {
        if (!model) return null;
        return ListReservationsResponse.newInstance(<ListReservationsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListReservationsResponse) {
        if (!obj) return;

        models.ListReservationsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListReservationsResponse): boolean {
        Object.setPrototypeOf(obj, ListReservationsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.net_savings === undefined) {
            this.net_savings = 0;
        }
        if (this.expiring_in_thirty_days === undefined) {
            this.expiring_in_thirty_days = 0;
        }
        if (this.on_demand_cost === undefined) {
            this.on_demand_cost = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.reservation_cost === undefined) {
            this.reservation_cost = 0;
        }
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.potential_cost_savings_recommended === undefined) {
            this.potential_cost_savings_recommended = 0;
        }
        if (this.filters) {
            models.FilterValue.fixupPrototype(this.filters);
        }
        if (this.reservations) {
            for (let val of this.reservations) {
                models.ReservationDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Filters available
     */
    filters: models.FilterValue;

    /**
     * Net savings value
     */
    net_savings: number;

    /**
     * How many days are left out for expiry in that month
     */
    expiring_in_thirty_days: number;

    /**
     * On Demand Cost Value
     */
    on_demand_cost: number;

    /**
     * Reservation
     */
    reservations: Array<models.ReservationDetails>;

    /**
     * Page Count
     */
    page_count: number;

    /**
     * Reservation Cost Value
     */
    reservation_cost: number;

    /**
     * Total Count
     */
    total_count: number;

    /**
     * Cost saved based on recommendation
     */
    potential_cost_savings_recommended: number;

}
